import lang from '../../common/lang/de';

export class RulesOperatorHelper {

    static maxLength(item) {
        return lang.formRules.maxLength.replace('{item}', item.toString());
    }

    static minLength(item) {
        return lang.formRules.minLength.replace('{item}', item.toString());
    }

    static validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    static errorValidateEmail(item) {
        return lang.formRules.failEmail.replace('{item}', item.toString());
    }

    static validateWebSite(webSite) {
        let response = true;
        if (webSite !== null && webSite !== '') {
            const re = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/;
            response = re.test(String(webSite).toLowerCase());
        }
        return response;
    }

    static errorValidateWebSite(item) {
        return lang.formRules.failWebSite.replace('{item}', item.toString());
    }

    static onlyNumbers(item) {
        const re = /^\d+$/;
        return re.test(String(item).toLowerCase());
    }

    static errorOnlyNumbers(item) {
        return lang.formRules.onlyNumbers.replace('{item}', item.toString());
    }
}